import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Lightbox from "./Lightbox";
import "./clientImageBrowser.scss";

const PAGE_SIZE = 12;


const ClientImageBrowser = ({ baseURL }) => {
    const API_URL = `${baseURL}/api/images`; // correct API route

    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [lightboxIndex, setLightboxIndex] = useState(null);

    // Build full static image URL
    const buildUrl = (file) => `${baseURL}/images/${file}`;

    // Pagination
    const totalPages = Math.ceil(images.length / PAGE_SIZE);
    const paginated = images.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

    // Load gallery image filenames
    useEffect(() => {
        const loadImages = async () => {
            setLoading(true);
            try {
                const res = await fetch(API_URL);
                const data = await res.json();
                setImages(data);
            } catch (err) {
                console.error("Gallery Load Error:", err);
            }
            setLoading(false);
        };
        loadImages();
    }, [API_URL]);

    return (
        <div className="galleryThemeWrapper">
            {/* Title */}
            <h1 className="galleryTitle">Our Gallery</h1>
            <p className="gallerySubtitle">Explore our premium dishes & ambience</p>

            {/* Grid Wrapper */}
            <div className="galleryGrid">
                {loading ? (
                    // Skeletons while loading
                    [...Array(PAGE_SIZE)].map((_, i) => (
                        <div className="gallerySkeleton" key={i}></div>
                    ))
                ) : (
                    // Image cards
                    paginated.map((filename) => (
                        <motion.div
                            key={filename}
                            className="galleryCard"
                            whileHover={{ scale: 1.04 }}
                            transition={{ duration: 0.25 }}
                        >
                            <img
                                src={buildUrl(filename)}
                                alt={filename}
                                className="galleryImage"
                                onClick={() =>
                                    setLightboxIndex(images.indexOf(filename))
                                }
                            />
                        </motion.div>
                    ))
                )}
            </div>

            {/* Pagination */}
            {!loading && (
                <div className="galleryPagination">
                    <button
                        disabled={page === 1}
                        onClick={() => setPage((p) => p - 1)}
                    >
                        Prev
                    </button>

                    <span>{page} / {totalPages}</span>

                    <button
                        disabled={page === totalPages}
                        onClick={() => setPage((p) => p + 1)}
                    >
                        Next
                    </button>
                </div>
            )}

            {/* Lightbox */}
            <Lightbox
                images={images.map((f) => buildUrl(f))}
                currentIndex={lightboxIndex}
                setIndex={setLightboxIndex}
                onClose={() => setLightboxIndex(null)}
            />
        </div>
    );
};

export default ClientImageBrowser;
